<template>
    <div v-if="!hideMe" :style="indent" >
        
        
        <input ref="cb" type="checkbox" @click="clicked" :checked="isSelected"/>
        <div class="treeNode left5 handCursor" :class="{bFilterHighlight: highlighted}"  @mouseover="hovering = true" @mouseleave="hovering = false"><span class="has-text-coolGreen"><b>::</b></span>{{listName}}</div>
    </div>
</template>

<script>
    import { AZEventBus } from './AZEventBus'
    import bFactory from '../shared/bundleFactory.js'

    export default { 
        name: 'tree',
        props: ['listName', 'children', 'depth', 'id', 'currCardId', 'aliasTgtId', 'selectedFromCopyCard', 'hideMe', 'editWindow', 'collabId'],
        data: function(){
            return {
                isSelected: false,
                isExpanded: false,
                highlighted: false,
                hovering: false,
            }
        },
        mounted(){
            var self = this;


            //this.checkIfSelected(true)

            AZEventBus.$on('treesCheckIfSelected', this.treesCheckIfSelectedHandler)
        },

        beforeDestroy: function(){
            var self = this
            AZEventBus.$off('treesCheckIfSelected', this.treesCheckIfSelectedHandler)
        },

        methods: {

            treesCheckIfSelectedHandler: function(msg){
                this.checkIfSelected()
            },


            clicked: function(){
                let msg = {};
                msg.id = this.id
                if(this.$refs.cb.checked == true){
                    msg.selected = true
                } else {
                    msg.selected = false
                }
                AZEventBus.$emit('onViewsTreeNodeClicked', msg)
                this.isSelected = !this.isSelected
            },
            
            checkIfSelected: function(fromMounted){
                
                let bundle = this.$root.app.bundles.find(e => {
                    return e.id == this.id
                })

                for(let i=0; i < bundle.items.length; i++){
                    if(bundle.items[i].id == this.currCardId){
                        if(this.depth > 0)
                            this.$parent.expandBranch()
                            
                        if(fromMounted){
                            this.isSelected = true;
                        }
                        
                        break;
                    }
                }

                if(this.selectedFromCopyCard){
                    if(this.depth > 0)
                        this.$parent.expandBranch()
                        
                    if(fromMounted){
                        this.isSelected = true;
                    }
                        
                }
            },
            
        },
        computed: {
            indent() {
                return this.depth == 0 ? '' : { transform: 'translate(30px)' }
            }
        }
    }
</script>